// extracted by mini-css-extract-plugin
module.exports = {"postSelection":"PostSelection_postSelection__3kB_P","title":"PostSelection_title__7Ql0v","subtitle":"PostSelection_subtitle__19HLT","mazeButton":"PostSelection_mazeButton__3XAXI"};